// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-blog-index-js": function componentSrcPagesBlogIndexJs() {
    return import("./../../src/pages/blog/index.js"
    /* webpackChunkName: "component---src-pages-blog-index-js" */
    );
  },
  "component---src-pages-contact-examples-js": function componentSrcPagesContactExamplesJs() {
    return import("./../../src/pages/contact/examples.js"
    /* webpackChunkName: "component---src-pages-contact-examples-js" */
    );
  },
  "component---src-pages-contact-file-upload-js": function componentSrcPagesContactFileUploadJs() {
    return import("./../../src/pages/contact/file-upload.js"
    /* webpackChunkName: "component---src-pages-contact-file-upload-js" */
    );
  },
  "component---src-pages-contact-index-js": function componentSrcPagesContactIndexJs() {
    return import("./../../src/pages/contact/index.js"
    /* webpackChunkName: "component---src-pages-contact-index-js" */
    );
  },
  "component---src-pages-contact-thanks-js": function componentSrcPagesContactThanksJs() {
    return import("./../../src/pages/contact/thanks.js"
    /* webpackChunkName: "component---src-pages-contact-thanks-js" */
    );
  },
  "component---src-pages-double-up-js": function componentSrcPagesDoubleUpJs() {
    return import("./../../src/pages/double-up.js"
    /* webpackChunkName: "component---src-pages-double-up-js" */
    );
  },
  "component---src-pages-event-index-js": function componentSrcPagesEventIndexJs() {
    return import("./../../src/pages/event/index.js"
    /* webpackChunkName: "component---src-pages-event-index-js" */
    );
  },
  "component---src-pages-menu-js": function componentSrcPagesMenuJs() {
    return import("./../../src/pages/menu.js"
    /* webpackChunkName: "component---src-pages-menu-js" */
    );
  },
  "component---src-pages-order-js": function componentSrcPagesOrderJs() {
    return import("./../../src/pages/order.js"
    /* webpackChunkName: "component---src-pages-order-js" */
    );
  },
  "component---src-pages-order-new-js": function componentSrcPagesOrderNewJs() {
    return import("./../../src/pages/order-new.js"
    /* webpackChunkName: "component---src-pages-order-new-js" */
    );
  },
  "component---src-pages-order-status-js": function componentSrcPagesOrderStatusJs() {
    return import("./../../src/pages/order-status.js"
    /* webpackChunkName: "component---src-pages-order-status-js" */
    );
  },
  "component---src-pages-orders-dashboard-js": function componentSrcPagesOrdersDashboardJs() {
    return import("./../../src/pages/orders-dashboard.js"
    /* webpackChunkName: "component---src-pages-orders-dashboard-js" */
    );
  },
  "component---src-pages-photos-js": function componentSrcPagesPhotosJs() {
    return import("./../../src/pages/photos.js"
    /* webpackChunkName: "component---src-pages-photos-js" */
    );
  },
  "component---src-pages-products-js": function componentSrcPagesProductsJs() {
    return import("./../../src/pages/products.js"
    /* webpackChunkName: "component---src-pages-products-js" */
    );
  },
  "component---src-pages-tags-index-js": function componentSrcPagesTagsIndexJs() {
    return import("./../../src/pages/tags/index.js"
    /* webpackChunkName: "component---src-pages-tags-index-js" */
    );
  },
  "component---src-templates-about-page-js": function componentSrcTemplatesAboutPageJs() {
    return import("./../../src/templates/about-page.js"
    /* webpackChunkName: "component---src-templates-about-page-js" */
    );
  },
  "component---src-templates-blog-post-js": function componentSrcTemplatesBlogPostJs() {
    return import("./../../src/templates/blog-post.js"
    /* webpackChunkName: "component---src-templates-blog-post-js" */
    );
  },
  "component---src-templates-event-post-js": function componentSrcTemplatesEventPostJs() {
    return import("./../../src/templates/event-post.js"
    /* webpackChunkName: "component---src-templates-event-post-js" */
    );
  },
  "component---src-templates-index-page-js": function componentSrcTemplatesIndexPageJs() {
    return import("./../../src/templates/index-page.js"
    /* webpackChunkName: "component---src-templates-index-page-js" */
    );
  },
  "component---src-templates-tags-js": function componentSrcTemplatesTagsJs() {
    return import("./../../src/templates/tags.js"
    /* webpackChunkName: "component---src-templates-tags-js" */
    );
  }
};